import { type FC } from 'react'
import Link from 'next/link'

import { Button } from '@wartek-id/button-v1'
import { Text } from '@wartek-id/text-v1'

import useSchoolContext from 'app/KinerjaKSPage/hooks/useSchoolContext'

interface CardPelaksanaanOtherProps {
  urlPath: string
}

const CardPelaksanaanOther: FC<CardPelaksanaanOtherProps> = ({ urlPath }) => {
  const { currentNpsn } = useSchoolContext()

  return (
    <>
      <div className="space-y-2 max-w-[437px]">
        <Text variant="heading-sm">Cek dokumen lainnya:</Text>
        <div className="border border-subdued rounded-lg flex items-center content-start gap-6 p-6">
          <div className="flex-1">
            <Text variant="body-bold">Perilaku Kerja</Text>
            <Text color="subdued">Laksanakan sesuai rencana.</Text>
          </div>

          <Link href={`${urlPath}/perilaku-kerja?id=${currentNpsn}`} passHref>
            <Button as="a" color="white" className="flex-none">
              Cek
            </Button>
          </Link>
        </div>
      </div>
    </>
  )
}
export default CardPelaksanaanOther
